module.exports = __webpack_public_path__ + "img/ic_prestige_clear_history.svg";